export const TaskStatus = {
    ACTIVE: 1,
    COMPLETED: 2,
    ARCHIVE: 3,
    DEACTIVE: 4
}